"use client";

import React from "react";
import { ChipiProvider } from "@chipi-stack/chipi-react";
import type { ChipiSDKConfig } from "@chipi-stack/types";

interface ChipiClientProviderProps {
  children: React.ReactNode;
  apiPublicKey: string;
  isInternalChipiDeveloper?: "True" | "False";
}

/**
 * Pure client component that handles all React hook imports
 * This component is marked with 'use client' to avoid server-side issues
 */
export function ChipiClientProvider({
  children,
  apiPublicKey,
  isInternalChipiDeveloper = "False",
}: ChipiClientProviderProps) {
  // Create config
  const config = React.useMemo(
    (): ChipiSDKConfig => ({
      apiPublicKey,
      isInternalChipiDeveloper: isInternalChipiDeveloper === "True" ? "True" : "False",
    }),
    [apiPublicKey, isInternalChipiDeveloper]
  );

  return <ChipiProvider config={config}>{children}</ChipiProvider>;
}
